import React from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import SEO from "../SEO/seo";

function QuotationnEx() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  const scaleFade = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  const imageZoom = {
    hidden: { scale: 1.05, opacity: 0 },
    visible: { scale: 1, opacity: 1 },
  };

  const slideLeftToRight = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRightT0Left = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };
  return (
    <>
      <SEO
        title="Quotation Explainer | Farm Construction Cost Breakdown by Kryzen"
        description="Finding this quotation overwhelming? Watch our detailed explainer video that reveals the secret to profitable farm construction — understand costs, ROI, and smart investment strategies."
        keywords="farm quotation explainer, hydroponic cost breakdown, farm construction budget, profitable farm setup, hydroponic quotation video, kryzen pricing explanation, ROI farming"
        canonical="https://alpha.kryzen.com/kryzen-quotation-explainer"
        ogTitle="Quotation Explainer | Farm Construction Cost Breakdown by Kryzen"
        ogDescription="Confused by your farm quotation? Our explainer video breaks down every cost and unveils how Kryzen helps you build a profitable hydroponic setup from the ground up."
        ogImage=""
        twitterTitle="Quotation Explainer | Secret to Profitable Farm Construction"
        twitterDescription="Not sure how to read your farm quotation? Watch Kryzen’s quotation explainer video to decode every cost and maximize ROI on your hydroponic farm investment."
      />
      <div>
        <Slider
          heding={"QUOTATION EXPLAINER"}
          paragraph={
            "Watch this detailed explainer video"
          }
        ></Slider>
        <div className="container mainDiv py-5">
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
            >
              kryzen QUOTATION EXPLAINER
            </motion.h1>

            <hr></hr>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lead mx-auto p-5"
              style={{ lineHeight: "1.8", fontSize: "25px" }}
            >
              Finding this quotation overwhelming?<br></br> Watch this detailed explainer
              video. quotation explainer secret of profitable farm construction.
            </motion.p>
          </div>

          <div>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/8WscAhKo2x8"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Quotation Video"
                style={{ height: "800px", width: "100%" }}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
}

export default QuotationnEx;
